var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3"}));
}

Cart.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Cart;

Cart.default = Cart;
